import { render, staticRenderFns } from "./work-wechat-manage.vue?vue&type=template&id=08bdfbc6"
import script from "./work-wechat-manage.vue?vue&type=script&lang=js"
export * from "./work-wechat-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bdfbc6')) {
      api.createRecord('08bdfbc6', component.options)
    } else {
      api.reload('08bdfbc6', component.options)
    }
    module.hot.accept("./work-wechat-manage.vue?vue&type=template&id=08bdfbc6", function () {
      api.rerender('08bdfbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechats/components/work-wechat-manage.vue"
export default component.exports